/* eslint-disable no-param-reassign */
// import { call } from 'redux-saga/effects';
import FrontSonda from '@gerenciatd/next.utils.front-sonda';
// import { getStaticContent } from '../adabyron.misc/index';
import { normalizeModulosContratos } from './public/index';

const normalizeCurrentModule = (moduleName, data, context) => {
  let itemNormalized = null;
  switch (moduleName) {
    case 'MODULO_PRINCPAL_CONTRATOS':
      itemNormalized = normalizeModulosContratos(data, context);
      break;
    default:
      itemNormalized = data?.fields || null;
  }
  return {
    name: moduleName,
    dataNormalized: itemNormalized,
  };
};

/**
 * Normaliza los modulos que vienen desde catálogo a una estructura válida
 * @param {Object[]} ModuleList - lista de los modulos  que viene desde catálogo
 * @returns {Object[]} - lista de modulos  normalizados
 */
export const normalizePublicModules = (response, context) => {
  const frontSonda = new FrontSonda({
    processName: 'normalizePublicModule',
    context,
    filePath: 'sagas/normalizers/public',
  });

  // REFINAMIENTO
  try {
    const resNormalized = {};
    const myModule = (response && response.data) || null;

    if (myModule && myModule.fields) {
      const currentModules = { ...myModule.fields };
      const fieldsInfoKeys = Object.keys(currentModules).sort();
      fieldsInfoKeys.forEach((fieldsInfoKey) => {
        const currentModule = currentModules[fieldsInfoKey];
        let currentModuleName = currentModule?.name || fieldsInfoKey;

        if (!currentModuleName) {
          currentModuleName = fieldsInfoKey.substring(
            fieldsInfoKey.indexOf('_') + 1,
            fieldsInfoKey.length
          );
        }

        const { name, dataNormalized } = currentModule
          ? normalizeCurrentModule(currentModuleName, currentModule, context)
          : null;
        if (name && dataNormalized) {
          if (Object.prototype.hasOwnProperty.call(resNormalized, name)) {
            const auxResNormalized = resNormalized[name];
            resNormalized[name] = [auxResNormalized];
            resNormalized[name].push(dataNormalized);
          } else {
            resNormalized[name] = dataNormalized;
          }
        }
      });
    }
    return resNormalized;
  } catch (error) {
    frontSonda.severalMessage({ error });
    return null;
  }
};

// export function* onErrorGetProductsByAliasOrion({ build, context, alias }) {
//   const myFrontSonda = new FrontSonda({
//     processName: 'onErrorGetProductsByAliasOrion',
//     context,
//     filePath: 'sagas/normalizers/public',
//   });
//   let mock;
//   try {
//     mock = yield call(getStaticContent, {
//       preRenderEnv: 'prod',
//       build,
//       resourcePath: `/static/json/mocks/particulares-mimovistar/public/${alias}.json`,
//       context,
//     });
//     myFrontSonda.errorMessage({
//       info: `Estamos mockeando ${alias}`,
//     });
//   } catch (error) {
//     myFrontSonda.severalMessage({
//       info: `Fallo mockeando ${alias}`,
//     });
//   }
//   return mock;
// }
